<script>
  import { navigate } from 'svelte-routing';
  import Button, { Label, Icon } from '@smui/button';
  import { isUnity, isDeveloper } from '../../util/unity';
  import { getAccountId } from '../../util/account';

  export let session;
  export let disabled = false;

  let cardLink = '';
  $: if (session) {
    if (
      (isUnity() && session.createdById !== getAccountId()) ||
      (isUnity() && isDeveloper() && session.createdById === getAccountId())
    ) {
      cardLink = `/sessions/lobby/${session.sessionId}`;
    } else {
      cardLink = `/qr/headset-login/?sessionId=${session.sessionId}`;
    }
  }

  function clickHandler(event) {
    navigate(cardLink);
  }
</script>

<Button id="join-session-button" on:click={clickHandler} variant="unelevated" class="join-session-button" {disabled}>
  <Icon class="material-icons" />
  <Label class="join-session-button__label">Join</Label>
</Button>

<style>
  :global(.join-session-button) {
    height: 45px;
    border-radius: 6px;
  }

  :global(.join-session-button:not(:disabled)) {
    background-color: var(--gigxr-theme-secondary-3c);
  }

  :global(.join-session-button:disabled) {
    color: #fff !important;
  }

  :global(.join-session-button .material-icons) {
    background-image: url('/assets/qr-icon.svg');
    background-repeat: no-repeat;
    background-size: 30px 30px;
    width: 30px;
    height: 30px;
  }

  :global(.join-session-button__label) {
    text-transform: uppercase;
    font-size: 16px;
  }

  @media (min-width: 1100px) {
    :global(.join-session-button) {
      border-radius: 6px 6px 0 0;
    }
  }
</style>
